import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  radio: {
    appearance: "none",
    cursor: "pointer",
    width: 16,
    height: 16,
    border: `2px solid ${theme.colors.TextSilver}`,
    borderRadius: "50%",
    display: "grid",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease",

    "&:disabled": {
      opacity: 0.5,
    },
    "&:checked": {
      appearance: "radio",
      width: 16,
      height: 16,
      accentColor: theme.colors.Primary,
      counterIncrement: "radioGreen",
      display: "flex",
      alignItems: "center",
    },
  },
}));
